// Business types offered when provisioning a site and during onboarding. The
// chosen type decides which services onboarding suggests first.
export const BUSINESS_TYPES = [
  'Barbershop',
  'Nail Salon',
  'Hair Salon',
  'Spa',
  'Massage Therapy',
  'Wellness',
  'Professional Services',
  'Other',
];

const SERVICE_SUGGESTIONS: Record<string, string[]> = {
  Barbershop: ['Haircut', 'Beard Trim', 'Haircut & Beard', 'Kids’ Haircut', 'Line Up', 'Hot Towel Shave'],
  'Nail Salon': ['Classic Manicure', 'Gel Manicure', 'Classic Pedicure', 'Gel Pedicure', 'Acrylic Full Set', 'Nail Art'],
  'Hair Salon': ['Haircut', 'Blowout', 'Hair Color', 'Highlights', 'Silk Press', 'Deep Conditioning'],
  Spa: ['Signature Facial', 'Body Scrub', 'Spa Package', 'Sauna Session', 'Brow Service', 'Makeup Application'],
  'Massage Therapy': ['Swedish Massage', 'Deep Tissue Massage', 'Sports Massage', 'Prenatal Massage', 'Hot Stone Massage', 'Chair Massage'],
  Wellness: ['Wellness Consultation', 'Yoga Session', 'Reiki Session', 'Meditation Session', 'Nutrition Consultation', 'Stretch Therapy'],
  'Professional Services': ['Consultation', 'Strategy Session', 'Initial Assessment', 'Follow-up Session', 'Coaching Session', 'Project Session'],
  Other: ['Consultation', 'Initial Appointment', 'Standard Service', 'Premium Service', 'Follow-up', 'Custom Service'],
};

export const suggestedServicesFor = (businessType?: string): string[] =>
  SERVICE_SUGGESTIONS[businessType ?? ''] ?? SERVICE_SUGGESTIONS.Other;
